import React from 'react';
import { formatNumber } from '@panel/commons/helpers/formatAmount';

import { currenciesBySite } from '@panel/commons/helpers';
import { ReactComponent as Score1 } from '../assets/img/Score1.svg';
import { ReactComponent as Score2 } from '../assets/img/Score2.svg';
import { ReactComponent as Score3 } from '../assets/img/Score3.svg';
import { ReactComponent as Score4 } from '../assets/img/Score4.svg';
import { ReactComponent as Score5 } from '../assets/img/Score5.svg';
import { ReactComponent as Score } from '../assets/img/Score.svg';
import { ReactComponent as Media } from '../assets/icons/icono_media.svg';
import { ReactComponent as Alta } from '../assets/icons/icono_alta.svg';
import { ReactComponent as Baja } from '../assets/icons/icono_baja.svg';

const site = process.env.REACT_APP_BUILD_SITE;
const { separator } = Object.values(currenciesBySite[site])[0];

/**
 * Formatea un número con el separador de miles.
 * @param {number|string|undefined} amount - El número o cadena a formatear.
 * @returns {string} - El número formateado con el separador de miles o "-" si es indefinido.
 */
export function formatWithThousandsSeparator(amount) {
  // Retornar '-' si el valor es undefined
  if (amount === undefined) return '-';

  // Convertir a número si llega como string
  const numericAmount = typeof amount === 'string' ? parseFloat(amount) : amount;

  // Verificar que sea un número válido
  if (Number.isNaN(numericAmount)) {
    return '-';
  }

  // Convertir el número a string y agregar el separador de miles
  return numericAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
}

export function ReturnLevelIcon(level) {
  switch (level) {
    case 1:
    case 2:
      return <Baja />;
    case 3:
    case 4:
      return <Media />;
    case 5:
      return <Alta />;
    default:
      return null;
  }
}

const svgMap = {
  1: Score1,
  2: Score2,
  3: Score3,
  4: Score4,
  5: Score5
};

export function createSvgComponent(level) {
  const SvgComponent = svgMap[level] || Score; // Usar Score como componente por defecto

  return () => <SvgComponent />;
}

/**
 * Return true if enabled new reputation
 *
 */
// deprecated - replaced by bumexFeature: NEW_REPUTATION_SECTION
export function enabledNewReputation() {
  const siteId = process.env.REACT_APP_BUILD_SITE;
  return ['24MX'].includes(siteId);
}

export function getColorLevel(id) {
  const numericId = parseInt(id, 10);

  const levelMap = {
    5: { color: '#067F22' },
    4: { color: '#80BD00' },
    3: { color: '#F5BD00' },
    2: { color: '#E48A37' },
    1: { color: '#D90D16' },
    0: { color: '#C8C8C8' }
  };

  return levelMap[numericId] || { color: '#000000' }; // Devuelve color negro por defecto si el id no está en el mapeo
}

export function getLevelInfo(level) {
  switch (level) {
    case 1:
    case 2:
      return 'panel.reputacion.tax.baja';
    case 3:
    case 4:
      return 'panel.reputacion.tax.media';
    case 5:
      return 'panel.reputacion.tax.alta';

    default:
      return 'panel.reputacion.tax.nolevel';
  }
}
export function getLevelBackground(level) {
  switch (level) {
    case 1:
    case 2:
      return '#FFEBEE';
    case 3:
    case 4:
      return '#FEF9E4';
    case 5:
      return '#EBF4EB';
    default:
      return '';
  }
}

export function getLevelInfoByPercent(value) {
  if (value >= 90) {
    return 5;
  }
  if (value >= 80 && value < 90) {
    return 3;
  }

  return 1;
}

export function getLevelSubtitleBypercent(value) {
  if (value === 100) {
    return 'panel.reputacion.calidad.complete';
  }
  if (value >= 1 && value < 99) {
    return 'panel.reputacion.calidad.incomplete';
  }

  return 'panel.reputacion.calidad.nodata';
}

export function getLevelTaxColour(level) {
  switch (level) {
    case 1:
    case 2:
      return '#A30A10';
    case 3:
    case 4:
      return '#CB7900';
    case 5:
      return '#2E6830';
    default:
      return '';
  }
}

/**
 * Se formatea un valor numérico.
 *
 * - Si el valor es `null`, `undefined` o `0`, devuelve `"-"`.
 * - Si el valor es exactamente `5`, devuelve `"5"` sin decimales.
 * - En cualquier otro caso, se redondea el valor a un decimal y lo devuelve como string,
 *   reemplazando comas por puntos en la representación decimal.
 *
 * @param {number} value - El valor numérico a formatear.
 * @returns {string} El valor formateado como string.
 */
export const formatValue = value => {
  if (!value || value === 0) return '-';
  if (value.toString() === '5') return '5';
  const roundedValue = Math.round(value * 10) / 10;
  return roundedValue
    .toFixed(1)
    .toString()
    .replace(',', '.');
};
